import "@pufflig/prompt-studio-ui/dist/style.css";
import "@pufflig/promptbook-document-editor/dist/style.css";
import "@pufflig/promptbook-prompt-editor/dist/style.css";

import "@/services/posthog/init";
import "@/services/react-scan/init";
import "@/services/sentry/init";

import { logger } from "@pufflig/logger";
import { pdfjs } from "@pufflig/promptbook-storage";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App.tsx";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf/pdf.worker.mjs";

logger.level = "silent";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
